module.exports = __webpack_public_path__ + "static/img/03.676934cf.jpg";